var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_57",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 42V21.95L3.8 25.15L2 22.75L8 18.2V12.5H11V15.9L24 6L46 22.8L44.2 25.15L40 21.95V42H8ZM11 39H22.5V31H25.5V39H37V19.65L24 9.75L11 19.65V39ZM8 10C8 8.46667 8.54167 7.16667 9.625 6.1C10.7083 5.03333 12 4.5 13.5 4.5C14.2083 4.5 14.8021 4.25 15.2812 3.75C15.7604 3.25 16 2.66667 16 2H19C19 3.5 18.4653 4.79167 17.3959 5.875C16.3264 6.95833 15.0278 7.5 13.5 7.5C12.8333 7.5 12.25 7.73958 11.75 8.21875C11.25 8.69792 11 9.29167 11 10H8Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1618774bcced1cdc719cc76223d8d226.svg";
export { ForwardRef as ReactComponent };